import { newProperty } from "../schema.generator";

const schema = [
  { ...newProperty("name", "string", true, "Name") },
];

export default schema;
